<xp-dialog *ngIf="showLeaveWithoutSavingDialog" class="leave-signup-dialog" [closeOnBackdrop]="true" (closed)="stayAndContinueSignup()">
    <xp-dialog-header class="leave-signup-header" heading="Leave without saving?" (closeClick)="stayAndContinueSignup()"></xp-dialog-header>
    <div class="leave-signup-body">
        <mat-icon class="leave-signup-warning-icon">warning</mat-icon>
        <p class="leave-signup-text">You have unsaved changes. If you leave now, your progress won't be saved.</p>
    </div>
    <div class="leave-signup-actions">
        <button mat-flat-button type="button" class="leave-signup-leave-btn" (click)="leaveSignupWithoutSaving()">Leave without saving</button>
        <button mat-flat-button type="button" class="leave-signup-stay-btn" (click)="stayAndContinueSignup()">Stay &amp; Continue</button>
    </div>
</xp-dialog>

<xp-dialog *ngIf="passChangedSuccess" class="password-success-dialog" ariaLabel="Password Changed Successfully!">
    <mat-card-content class="t-align-center">
        <img src="../Content/xpress-app/images/pass-change-success.gif" class="mg-auto mt-3" width="108" height="108" alt="Password changed">
        <div class="discard-header t-align-center font-20 mb-3">Password Changed Successfully!</div>
        <div class="discard-text t-align-center">You will now be redirected to the login page.</div>
    </mat-card-content>
    <mat-card-actions align="end">
        <button mat-flat-button color="primary" class="submit-btn" (click)="login()">Okay</button>
    </mat-card-actions>
</xp-dialog>

<xp-dialog *ngIf="accountCreationInProgress" class="status-dialog" ariaLabel="Creating Your Account">
    <mat-card-content class="t-align-center flex flex-column align-items-center">
        <xp-loading [diameter]="48" class="my-5"></xp-loading>
        <p class="mb-0 font-semibold text-xl text-blue-800">Creating Your Account</p>
        <div class="acc-creation-txt text-small-normal">Please hold while we set up your Xpress Operator Account</div>
    </mat-card-content>
</xp-dialog>

<xp-dialog *ngIf="verifyingEmailInProgress" class="status-dialog" ariaLabel="Verifying email in progress">
    <mat-card-content class="t-align-center flex flex-column align-items-center">
        <xp-loading [diameter]="48" class="my-5"></xp-loading>
        <p class="text-xl text-blue-800 mb-1 font-semibold">Verifying email in progress</p>
        <p class="acc-creation-txt text-sm text-gray-600 mb-3">Please hold while we set up your Xpress Operator Account</p>
    </mat-card-content>
</xp-dialog>

<xp-loading *ngIf="isLoadingOverlay" class="loading-overlay" [overlay]="true" [diameter]="48"></xp-loading>
<div class="flex"
     [ngClass]="{
        'merchant-forgot-pass': merchantResetPassword || tourOperatorResetPassword,
        'justify-content-center': !merchantResetPassword && !tourOperatorResetPassword && !operatorResetPassword
     }">
    <div>
        <div [ngClass]="{
                'signup-form': !merchantResetPassword && !tourOperatorResetPassword && !operatorResetPassword,
                'signup-page mg-auto': operatorResetPassword
             }"
             [style]="operatorResetPassword ? {'margin-top': formMarginTop + 'px'} : null">
        <img class="signup-imglogo" src="../Content/xpress-app/images/operator/xpress_logo_operators.svg" />

        <div class="signup-body">
            <xp-back-button class="mt-3 back-to-login-btn w-auto"
                            iconSrc="../Content/xpress-app/images/operator/signup/arrow-left.svg"
                            (click)="alwaysBackToLogin()">Back to Log In</xp-back-button>

            <ng-container *ngIf="!operatorResetPassword && !merchantResetPassword && !tourOperatorResetPassword">
                <div class="signup-stepper">
                    <ng-container *ngFor="let step of signupSteps; let i = index; let last = last">
                        <div class="signup-step-item">
                            <div class="signup-step-circle {{stepStateClass(step.state)}}"
                                 [class.signup-step-clickable]="canGoToStep(step.target)"
                                 (click)="goToStep(step.target)">
                                <img *ngIf="isStepPassed(step.state); else stepNumber" src="{{SignupParams.PassedStepIconPath}}" alt="" />
                                <ng-template #stepNumber>{{i + 1}}</ng-template>
                            </div>
                            <div class="signup-step-label {{stepStateClass(step.state)}}">{{step.label}}</div>
                        </div>
                        <div class="signup-step-connector"
                             *ngIf="!last"
                             [class.signup-step-connector-passed]="isStepPassed(step.state)"></div>
                    </ng-container>
                </div>

                <div class="flex mt-3 back-to-login-btn w-auto" (click)="backToLogin()"
                    *ngIf="currentStep !== SignupStepEnum.OperatorDetails">
                    <img src="../Content/xpress-app/images/operator/signup/arrow-left.svg" alt="" /><span
                        class="text-small-bold back-to-login-text w-auto">Back to <ng-container
                            *ngIf="currentStep === SignupStepEnum.VerifyEmailOTP || currentStep === SignupStepEnum.BusinessRequirements">Operator's
                            Details</ng-container>
                        <ng-container *ngIf="currentStep === SignupStepEnum.AccountCredentials">Business Requirements</ng-container>
                        <ng-container *ngIf="currentStep === SignupStepEnum.ReviewSubmit">Password</ng-container></span>
                </div>

                <div class="mb-2 title">{{title}}</div>
                <div class="mb-2 subtitle" *ngIf="currentStep !== SignupStepEnum.VerifyEmailOTP">{{subtitle}}</div>

                <ng-container *ngIf="currentStep === SignupStepEnum.OperatorDetails">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>Company name</mat-label>
                        <input matInput
                               type="text"
                               name="companyName"
                               required
                               [(ngModel)]="operator.CompanyName"
                               #companyNameCtrl="ngModel" />
                        <mat-error *ngIf="companyNameCtrl.hasError('required')">Field is required</mat-error>
                    </mat-form-field>

                    <div class="flex gap-10">
                        <mat-form-field appearance="outline" class="width-50" subscriptSizing="dynamic">
                            <mat-label>First Name</mat-label>
                            <input matInput
                                   type="text"
                                   name="firstName"
                                   required
                                   [(ngModel)]="operator.FirstName"
                                   #firstNameCtrl="ngModel" />
                            <mat-error *ngIf="firstNameCtrl.hasError('required')">Field is required</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="width-50" subscriptSizing="dynamic">
                            <mat-label>Last Name</mat-label>
                            <input matInput
                                   type="text"
                                   name="lastName"
                                   required
                                   [(ngModel)]="operator.LastName"
                                   #lastNameCtrl="ngModel" />
                            <mat-error *ngIf="lastNameCtrl.hasError('required')">Field is required</mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic"
                                    [ngClass]="{'email-available': isEmailAvailable()}">
                        <mat-label>Email</mat-label>
                        <input matInput
                               type="email"
                               name="operatorEmail"
                               required
                               [pattern]="Utils.emailRegex"
                               [(ngModel)]="operator.Email"
                               #emailCtrl="ngModel"
                               [errorStateMatcher]="emailErrorMatcher"
                               (ngModelChange)="onEmailChange()"
                               (focusout)="checkEmailExist()" />
                        <mat-icon *ngIf="isEmailAvailable()" matSuffix class="email-available-icon">check</mat-icon>
                        <mat-hint *ngIf="isEmailAvailable()" class="email-available-hint">This email is available.</mat-hint>
                        <mat-error *ngIf="emailCtrl.hasError('required')">Field is required</mat-error>
                        <mat-error *ngIf="emailCtrl.hasError('pattern')">Invalid email</mat-error><mat-error *ngIf="emailAlreadyExist && !emailCtrl.hasError('required') && !emailCtrl.hasError('pattern')">Already in
                            use. Please use another email. <span class="text-blue-800 underline font-bold cursor-pointer"
                                (click)="backToLogin()">Log in instead</span></mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>Address</mat-label>
                        <input matInput
                               type="text"
                               name="operatorAddress"
                               autocomplete="off"
                               [(ngModel)]="operator.Address"
                               [matAutocomplete]="addressAuto"
                               (ngModelChange)="searchPlaces($event)" />
                        <mat-hint *ngIf="addressSearchError" class="address-search-error">{{ addressSearchError }}</mat-hint>
                        <mat-autocomplete #addressAuto="matAutocomplete"
                                          class="address-autocomplete-panel"
                                          (optionSelected)="onAddressSelected($event.option.value)">
                            <mat-option *ngFor="let suggestion of addressSuggestions" [value]="suggestion.text" class="address-option">
                                <div class="address-option-main">{{ suggestion.mainText || suggestion.text }}</div>
                                <div *ngIf="suggestion.secondaryText" class="address-option-secondary">{{ suggestion.secondaryText }}</div>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-checkbox [(ngModel)]="operator.IsTermsAccepted" (focusout)="stepValidation()" class="terms-checkbox">
                        I agree to Xpress' <a class="text-small-bold link" href="https://www.xpress.ph/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a class="text-small-bold link" href="https://www.xpress.ph/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    </mat-checkbox>
                    <xp-message *ngIf="termsErrorVisible" class="terms-error" severity="error" [plain]="true">Terms and Policy should be accepted</xp-message>
                </ng-container>

                <!-- OTP -->
                 <ng-container>
                    <one-time-password 
                    *ngIf="currentStep === SignupStepEnum.VerifyEmailOTP" 
                    [ProcessId]="signUpProcessId"
                    (verifiedOtp)="onOtpVerified($event)">
                    </one-time-password>
                 </ng-container>

                <ng-container *ngIf="currentStep === SignupStepEnum.BusinessRequirements">
                    <div class="border-1 border-solid border-round border-gray-50 p-3 bg-white mb-3">
                        <div class="bg-gray-50 border-round border-dashed  border-gray-100 p-3 flex justify-content-between align-items-center mb-1">
                            <div class="flex flex-column">
                                <p class="font-bold text-xl mb-0">Government issued ID</p>
                                <p class="text-sm text-gray-500">Upload JPG, JPEG, PNG, or PDF files (Max 10 MB)</p>
                            </div>

                            <input #govIdFileInput style="display: none" type="file"
                                   accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
                                   (change)="fileBrowseHandler(BusinessDocumentsEnum.GovernmentIssuedId, $event)">

                            <button mat-button color="primary" type="button" class="browse-files-btn flex gap-2 text-blue-500" [disabled]="operator.GovIdData.length >= 2 || (govIdProgressBar > 0 && govIdProgressBar < 100)" (click)="govIdFileInput.click()">
                                <mat-icon class="scale-icon-150">upload</mat-icon>
                                <p class="text-small-bold text-blue-500">{{govIdProgressBar && govIdProgressBar < 100 ? 'Uploading...' : 'Browse Files'}}</p>
                            </button>
                        </div>

                        <div class="flex mb-3 gap-2 align-items-center">
                            <mat-icon class="text-blue-500">info</mat-icon>
                            <p class="text-sm">Upload up to 2 documents</p>
                        </div>

                        <p *ngIf="govIdUploadError" class="text-sm mb-3" style="color: #E24C4C;">
                            File was not accepted. Use .pdf, .jpg, .jpeg, or .png (max 10MB).
                        </p>

                        <div class="border-1 border-round border-gray-50 border-solid bg-blue-50 p-2" *ngIf="operator.GovIdData.length">
                            <xp-file-row class="gov-id-file-row"
                                         *ngFor="let file of operator.GovIdData; let i = index"
                                         [ngClass]="{'top-border': i > 0}"
                                         [thumbSrc]="getGovIdPreviewSrc(file)"
                                         [name]="file.name"
                                         [caption]="formatFileSizeMb(file.size) + ' MB'"
                                         removeIcon="delete_outline"
                                         removeLabel="Delete file"
                                         (remove)="deleteUpload(BusinessDocumentsEnum.GovernmentIssuedId, file)"></xp-file-row>
                        </div>
                    </div>

                </ng-container>

                <div *ngIf="currentStep === SignupStepEnum.AccountCredentials" class="relative">
                    <xp-password-field class="w-100 mb-3"
                                       label="Password"
                                       [(value)]="operator.Password"
                                       (valueChange)="checkIsPasswordEqual()"
                                       errorText="Password is required"
                                       [showError]="passwordTouched && !operator.Password"
                                       (focused)="openPasswordTips()"
                                       (blurred)="closePasswordTips(); passwordTouched = true"></xp-password-field>

                    <div *ngIf="showPasswordTips" class="signup-password-tips signup-password-tips--step">
                        <xp-password-strength [password]="operator.Password"
                                              [minLength]="SignupParams.PassMinLength"
                                              header="Pick a password"
                                              [ruleLabels]="stepPasswordRules"
                                              [scoreLabels]="passwordScoreLabels"></xp-password-strength>
                    </div>

                    <xp-password-field class="w-100"
                                       label="Confirm Password"
                                       [(value)]="operator.ConfirmPassword"
                                       (valueChange)="checkIsPasswordEqual()"
                                       errorText="Password do not match."
                                       [showError]="confirmPasswordTouched && !isPasswordEqual"
                                       (blurred)="confirmPasswordTouched = true"></xp-password-field>
                    <xp-message *ngIf="accErrorMsg" class="files-err" severity="error" [plain]="true">{{ accErrorMsg }}</xp-message>
                </div>

                <div *ngIf="currentStep === SignupStepEnum.ReviewSubmit" class="review-submit">
                    <section class="review-section">
                        <div class="review-section-header">
                            <div class="flex align-items-center gap-2">
                                <h3 class="review-section-title">Operator's Details</h3>
                                <xp-badge class="review-complete-badge" icon="check">Complete</xp-badge>
                            </div>
                            <button mat-button type="button" class="review-edit-btn" (click)="editReviewSection(SignupStepEnum.OperatorDetails)">
                                <mat-icon>edit</mat-icon>
                                Edit
                            </button>
                        </div>
                        <xp-info-row class="review-row" label="Company Name">{{ operator.CompanyName }}</xp-info-row>
                        <xp-info-row class="review-row" label="First Name">{{ operator.FirstName }}</xp-info-row>
                        <xp-info-row class="review-row" label="Last Name">{{ operator.LastName }}</xp-info-row>
                        <xp-info-row class="review-row" label="Email">{{ operator.Email }}</xp-info-row>
                        <xp-info-row class="review-row review-row--wrap" label="Address">{{ operator.Address }}</xp-info-row>
                    </section>

                    <section class="review-section">
                        <div class="review-section-header">
                            <div class="flex align-items-center gap-2">
                                <h3 class="review-section-title">Business Requirements</h3>
                                <xp-badge class="review-complete-badge" *ngIf="operator.GovIdData.length" icon="check">Complete</xp-badge>
                                <xp-badge class="review-pending-badge" *ngIf="!operator.GovIdData.length" icon="schedule">Pending</xp-badge>
                            </div>
                            <button mat-button type="button" class="review-edit-btn" (click)="editReviewSection(SignupStepEnum.BusinessRequirements)">
                                <mat-icon>edit</mat-icon>
                                Edit
                            </button>
                        </div>
                        <div *ngIf="!operator.GovIdData.length" class="review-empty-card">
                            <mat-icon class="review-empty-icon">schedule</mat-icon>
                            <div class="flex flex-column">
                                <span class="review-empty-title">Documents not uploaded yet</span>
                                <span class="review-empty-subtitle">Add your business documents anytime before approval.</span>
                            </div>
                        </div>
                        <xp-file-row *ngFor="let file of operator.GovIdData; let i = index"
                                     class="review-file"
                                     [thumbSrc]="getGovIdPreviewSrc(file)"
                                     [name]="file.name"
                                     [caption]="formatFileSizeMb(file.size) + ' MB'"></xp-file-row>
                    </section>

                    <section class="review-section review-section-last">
                        <div class="review-section-header">
                            <div class="flex align-items-center gap-2">
                                <h3 class="review-section-title">Password Setup</h3>
                                <xp-badge class="review-complete-badge" icon="check">Complete</xp-badge>
                            </div>
                            <button mat-button type="button" class="review-edit-btn" (click)="editReviewSection(SignupStepEnum.AccountCredentials)">
                                <mat-icon>edit</mat-icon>
                                Edit
                            </button>
                        </div>
                    </section>

                    <xp-message *ngIf="accErrorMsg" class="files-err" severity="error" [plain]="true">{{ accErrorMsg }}</xp-message>
                </div>
            </ng-container>

            <ng-container *ngIf="operatorResetPassword || merchantResetPassword || tourOperatorResetPassword">
                <div class="login-block-title mt-4 mb-4">
                    <div class="mb-2 login-title">Create new password</div>
                    <div class="login-subtitle">Please create new password for your account
                    </div>
                </div>

                <xp-password-field class="w-100"
                                   label="New Password"
                                   [(value)]="operator.Password"
                                   (focused)="openPasswordTips()"
                                   (blurred)="closePasswordTips()"></xp-password-field>

                <div *ngIf="showPasswordTips" class="signup-password-tips signup-password-tips--reset">
                    <xp-password-strength [password]="operator.Password"
                                          [minLength]="SignupParams.PassMinLength"
                                          header="Password strength:"
                                          [ruleLabels]="resetPasswordRules"
                                          [scoreLabels]="passwordScoreLabels"></xp-password-strength>
                </div>

                <xp-password-field class="w-100"
                                   label="Confirm Password"
                                   [(value)]="operator.ConfirmPassword"></xp-password-field>
                <xp-message *ngIf="accErrorMsg" class="files-err" severity="error" [plain]="true">{{ accErrorMsg }}</xp-message>
            </ng-container>

            <div class="flex mt-2 w-100">
                <button *ngIf="!tourOperatorResetPassword && !merchantResetPassword && !operatorResetPassword && !isOtpRequest"
                        mat-flat-button color="primary" type="button" class="signup-btn text-small-bold w-100"
                        [disabled]="!canContinue()" (click)="continue()">{{btnContinueText}}</button>
                <button *ngIf="operatorResetPassword || merchantResetPassword || tourOperatorResetPassword"
                        mat-flat-button color="primary" type="button" class="signup-btn text-small-bold w-100"
                        [disabled]="!canSubmit()" (click)="changePassword()">Submit</button>
            </div>

            <ng-container *ngIf="currentStep === SignupStepEnum.BusinessRequirements && !operator.GovIdData.length">
                <div class="or-divider flex align-items-center gap-2">
                    <span class="or-divider-line"></span>
                    or
                    <span class="or-divider-line"></span>
                </div>

                <button mat-button color="primary" type="button" (click)="doItLater()">Do it later</button>
            </ng-container>
        </div>
        </div>

        <div class="signup-page-build-number">Xpress Operator's Portal Version {{buildNumber}}</div>
    </div>

    <img *ngIf="merchantResetPassword || tourOperatorResetPassword" class="merchant-forgot-logo" src="../Content/xpress-app/images/partner-login.svg" />
</div>
